import type { ArtefactKind } from "@esi/shared";
import { File, FileCode, FileText, type LucideIcon, Shapes, Table2, Workflow } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS: Record<ArtefactKind, LucideIcon> = {
  markdown: FileText,
  code: FileCode,
  mermaid: Workflow,
  svg: Shapes,
  csv: Table2,
  file: File,
};

/** The kind's icon; decorative (the kind is always said in words beside it). */
export function KindIcon({ kind, className }: { kind: ArtefactKind; className?: string }) {
  const Icon = ICONS[kind];
  return <Icon aria-hidden="true" strokeWidth={1.75} className={cn("size-4", className)} />;
}
